import { render, staticRenderFns } from "./Jira.vue?vue&type=template&id=c43c4540&"
import script from "./Jira.vue?vue&type=script&lang=ts&"
export * from "./Jira.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports